export async function getWarehouseSingleOrderConfiguration(jwtToken) {
    const response = await fetch("/api/warehouseConfiguration/single-order",
        {
            method: "GET",
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        }
    );

    if (!response.ok) {
        throw new Error("Impossibile caricare la configurazione warehouse.");
    }

    return response.json();
}

export async function getWarehouseProfile(jwtToken) {
    const response = await fetch("/api/warehouseConfiguration/profile",
        {
            method: "GET",
            headers: {
                Authorization: `Bearer ${jwtToken}`
            }
        }
    );

    if (!response.ok) {
        throw new Error("Impossibile caricare il profilo warehouse.");
    }

    return response.json();
}